import { Contact, ContactAddress } from 'domains/orgDomain';
import api from 'utils/api';
import {
  ContactLevelEnum,
  SaveUserDefaultContactAddressParams,
} from './../domains/orgDomain';

const contactService = {
  getUserAvlContacts: async (userId?: number) => {
    return api.get<Contact[]>(
      userId
        ? `/api/contacts/user-avl?userId=${userId}`
        : `/api/contacts/user-avl`
    );
  },

  getOrgAvlContactsByOrgIdList: async (orgIdList: number[]) => {
    return api.post<Contact[]>(`/api/contacts/org-avl/by-orgs`, orgIdList);
  },

  getOrgAvlContacts: async (orgId: number) => {
    return api.get<Contact[]>(`/api/contacts/org-avl/${orgId}`);
  },

  addUserContact: async (contact: Partial<Contact>) => {
    return api.post<Contact>(`/api/contacts`, {
      contactLevel: ContactLevelEnum.USER,
      firstName: contact.firstName,
      lastName: contact.lastName,
      company: contact.company,
    });
  },

  addUserContactWithAddress: async (
    contact: Partial<Contact>,
    address: Partial<ContactAddress>
  ) => {
    return api.post<Contact>(`/api/contacts/with-address`, {
      contact: {
        contactLevel: contact.contactLevel || ContactLevelEnum.USER,
        firstName: contact.firstName,
        lastName: contact.lastName,
        company: contact.company,
        phoneNumber: contact.phoneNumber,
        email: contact.email,
      },
      address,
    });
  },

  addressValidation: async (address: Partial<ContactAddress>) => {
    return api.post<Contact[]>(
      `/api/shipping/ups/av`,
      { ...address, addressLine: address.addressLine1 },
      {
        useGlobalErrorHandler: false,
      }
    );
  },

  addUserDefaultContactWithAddress: async (
    params: SaveUserDefaultContactAddressParams
  ) => {
    return api.post<Contact>(`/api/contacts/with-address-as-default`, params);
  },
};
export default contactService;
